module.exports = __webpack_public_path__ + "static/img/relação_de_darfs_pagos.5517e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loja/relação_de_darfs_pagos.png
// module id = 838
// module chunks = 0